export default {
    open: "Réponds maintenant",
    approve: "Approuver maintenant",
    impersonation: {
        title: "Vous commandez au nom de «{name}»",
        cta: "Revenez à moi-même",
    },
    "You have an unapproved orders": "Vous avez des commandes à approuver",
    "You have orders to approve": "Vous avez des commandes à approuver"
}